import React from "react";
import {
  DatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
} from "@material-ui/pickers";
import {
  KeyboardArrowRight as KeyboardArrowRightIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
} from "@material-ui/icons";

export default (props: MuiDatePickerProps) => (
  <MuiDatePicker
    autoOk
    showTodayButton
    format="yyyy-MM-dd"
    cancelLabel="キャンセル"
    todayLabel="今日"
    leftArrowIcon={<KeyboardArrowLeftIcon />}
    rightArrowIcon={<KeyboardArrowRightIcon />}
    InputLabelProps={{ shrink: true }}
    {...props}
  />
);
